import React from 'react';
import { Product } from 'shared/types/product/Product';
import { FEATURE_FLAG_LIST, useFeatureFlags } from 'hooks';
import { Tastic } from 'types/tastic';
import WhatsNewCardGroup, { WhatsNewCardsProps } from 'ui/home/whats-new-card';

const WhatsNewCardGroupTastic = ({ data }: Tastic<{ items: Product[] }, WhatsNewCardsProps>) => {
  const { isFeatureEnabled } = useFeatureFlags();
  return isFeatureEnabled(FEATURE_FLAG_LIST.HOME_PAGE) ? <WhatsNewCardGroup {...data} /> : null;
};

export default WhatsNewCardGroupTastic;
